import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIRoutes } from "APIRoutes";
import axios from "utils/axios";
import { utils } from "utils/utils";

export interface AuthDto {
  loading: boolean;
}

export const handleForgotPassword = createAsyncThunk(
  "auth/handleForgotPassword",
  async (data: any) => {
    const response: any = await axios.post(
      APIRoutes.ADMIN_FORGOT_PASSWORD,
      data
    );
    if (response.data?.statusCode) {
      utils.toastError(response.data?.message);
      return;
    }
    return {
      status: response?.data?.status ?? false,
      message: response?.data?.message ?? "",
    };
  }
);

export const changeAdminPassword = createAsyncThunk(
  "auth/changeAdminPassword",
  async (data: any) => {
    const response: any = await axios.post(
      APIRoutes.ADMIN_RESET_PASSWORD,
      data
    );
    if (response.data?.statusCode) {
      utils.toastError(response.data?.message);
      return;
    }
    return {
      status: response?.data?.status ?? false,
      message: response?.data?.message ?? "",
    };
  }
);

const initialState: AuthDto = {
  loading: false,
};

export const auth = createSlice({
  name: "auth",
  initialState,
  reducers: {},
});

export default auth.reducer;
